import React from 'react';

const PPETable = ({ columns, data, currency, isAdhoc }) => {
  return (
    <table className="ppe-table-rebuild table-adhoc-fixed">
      <thead>
        <tr>
          {columns.map((columnData) => (
            <th key={columnData} className="font-bold capitalize">
              {columnData}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data?.map(
          (ppe) => Boolean(ppe?.isAdhoc) === isAdhoc && (
            <tr key={ppe?.componentName}>
                <td>
                  <label>{ppe?.componentName}</label>
                </td>
                <td>
                  <label>{ppe?.measurement}</label>
                </td>
                <td>
                  <label>{ppe?.quantity}</label>
                </td>
                <td>
                  <label>
                    {Intl.NumberFormat('en-IN', {
                      minimumFractionDigits: 2
                    }).format(currency === 'USD' ? ppe?.unitPriceUsd : ppe?.unitPrice)}
                  </label>
                </td>
                <td>
                  <label>
                    {Intl.NumberFormat('en-IN', {
                      minimumFractionDigits: 2
                    }).format(
                      currency === 'USD'
                        ? ppe?.quantity * ppe?.unitPriceUsd
                        : ppe?.quantity * ppe?.unitPrice
                    )}
                  </label>
                </td>
            </tr>
        )
        )}
      </tbody>
    </table>
  );
};

export default PPETable;
